import { onSnapshot } from 'firebase/firestore'
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth'
import { firestoreDoc } from './firestoreUtil'
import store from '../store'

let authentication

const setAuthenticationApp = app => {
  authentication = getAuth(app)
}

const firebaseAuth = () => authentication

const getAccount = () => getAuth().currentUser

const getAccountId = () => {
  const account = getAccount()
  return account ? account.uid : ''
}

let accountIdTokenUnsubscribe

const updateStoreClaims = claims => store.dispatch('updateIdTokenClaims', claims || {})

const unsubscribeRefreshIdToken = () => {
  if (accountIdTokenUnsubscribe) {
    accountIdTokenUnsubscribe()
    accountIdTokenUnsubscribe = null
  }
  updateStoreClaims()
}

const observeAccountIdTokenRefresh = async (account) => {
  if (!(account && account.uid && account.getIdToken)) { return }

  unsubscribeRefreshIdToken()
  const tokenRefreshDoc = firestoreDoc(`account/${account.uid}/account-trigger/id-token-refresh`)
  accountIdTokenUnsubscribe = onSnapshot(tokenRefreshDoc, async () => {
    await account.getIdToken(true)
    const idToken = await account.getIdTokenResult()
    updateStoreClaims(idToken.claims)
  })
}

const onLogout = () => unsubscribeRefreshIdToken()

const signOut = () => firebaseSignOut(authentication)

export default {
  getAccount,
  getAccountId
}
export {
  setAuthenticationApp,
  firebaseAuth,
  getAccount,
  getAccountId,
  onLogout,
  observeAccountIdTokenRefresh,
  signOut
}
